import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionQuantityController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionQuantityController.php:13
* @route '/api/admin/workspaces/subscriptions/quantity'
*/
export const update = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/api/admin/workspaces/subscriptions/quantity',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionQuantityController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionQuantityController.php:13
* @route '/api/admin/workspaces/subscriptions/quantity'
*/
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Api\Workspace\UpdateSubscriptionQuantityController::__invoke
* @see app/Http/Controllers/Admin/Api/Workspace/UpdateSubscriptionQuantityController.php:13
* @route '/api/admin/workspaces/subscriptions/quantity'
*/
update.put = (options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(options),
    method: 'put',
})

const quantity = {
    update: Object.assign(update, update),
}

export default quantity